// @ts-nocheck
import React, { useState } from "react";
import genRequest from "includes/request";
import { usePopper } from "react-popper";
import { useQuery, useQueryClient } from "react-query";
import { ReactionButton } from "Pages/Reactions/AdminReactionsPage";
import "./ReactionsPopper.css";
import useAccount from "classes/Accounts/hooks/useAccount";

export default function PostReactionsPopper({ postId, postTypeId, close, referenceElement }) {
	// const [popperElement, setPopperElement] = useState(null);
	const { account } = useAccount();
	// const { styles, attributes } = usePopper(referenceElement, popperElement, {
	// 	placement: "top"
	// });

	const { isLoading, data } = useQuery(
		["reaction-types", "default", postTypeId, account.companyId],
		() => genRequest(`reaction-types/default/${postTypeId}/${account.companyId}`),
	);

	if (isLoading || !data?.length)
		return (false);

	return (
		<div
			className="ReactionsPopper"
			// ref={setPopperElement}
			onMouseLeave={close}
		// style={styles.popper}
		// {...attributes.popper}
		>
			<ReactionsList item={data[0]} postId={postId} />
		</div>
	);
}

export function PostReactions({ postId, onClick, title, titleClassName }) {
	const { isLoading, data } = useQuery(
		["posts", postId, "reactions"],
		() => genRequest("posts/" + postId + "/reactions")
	);

	if (isLoading || !data?.length)
		return (false);

	if (title)
		return (
			<div>
				<div className={"mb-1" + (titleClassName ? " " + titleClassName : "")}>{title}</div>
				<PostReactions postId={postId} onClick={false} />
			</div>
		);
	return (
		<ReactionsList
			item={data[0]}
			postId={postId}
			onClick={onClick}
		/>
	);
}

export function ReactionsList(props) {
	const { account } = useAccount();
	const QCL = useQueryClient();
	const { item, postId, onClick } = props;

	const unReact = () => genRequest(
		"posts/" + postId + "/reactions/employee/" + account.employeeId,
		null,
		"delete"
	);

	const sendReact = (reaction) => genRequest(
		"posts/" + postId + "/react",
		{
			// Backend stores this on PostReaction.reaction_id (legacy column
			// name) but the value is the actual reaction's id, NOT its
			// reactionTypeId — see posts.controller.ts:react.
			reactionTypeId: reaction.id,
		},
		"post"
	);

	const handleClick = (reac) => {
		if (onClick === false)
			return (false);
		else if (onClick)
			onClick(reac);
		else {
			// Refetch every cache that derives from reactions: the
			// per-emoji counts in the popper, the post-level reactions
			// list, AND the legacy likes endpoint — reactions.service
			// now syncs employee_liked_posts + posts.likes_count when a
			// thumbs reaction is added/removed (v1 parity), so the
			// bottom-bar counter has to refetch too.
			let req = unReact()
				.then(() => sendReact(reac))
				.then(() =>
					Promise.all([
						QCL.refetchQueries(["LT_Employe_Reaction_Post"]),
						QCL.refetchQueries(["posts", postId, "reactions"]),
						QCL.refetchQueries(["LtEmployesLikedposts", "PostId", postId]),
					]),
				);
			return (req);
		}
	};

	const { data, isLoading } = useQuery(
		["reactions", "typed", item.reactionTypeId],
		() => genRequest("reactions/typed/" + item.reactionTypeId) // NEEDS_BACKEND: add GET reactions/typed/:reactionTypeId
	);

	if (isLoading || !data?.length)
		return (false);

	return (
		<div
			className={"ReactionListCell d-flex w-100 justify-content-around align-items-center px-2" + (onClick === false ? " pe-none" : "")}>
			{
				data.map((a) => {
					if (a.id == null) return null;
					return (
						<ReactionButton
							key={a.id}
							{...a}
							onClick={() => handleClick(a)}
							countQueryKey={["LT_Employe_Reaction_Post", "PostIdAndReactionId", postId, a.id]}
							countQueryFn={() => genRequest("posts/" + postId + "/reactions/" + a.id)}
						/>
					);
				})
			}
		</div>
	);
}

